/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RevokeChatSessionSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RevokeChatSessionSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RevokeChatSessionSecurity = {
  option1?: RevokeChatSessionSecurityOption1 | undefined;
  option2?: RevokeChatSessionSecurityOption2 | undefined;
};

export type RevokeChatSessionRequest = {
  /**
   * The chat session token to revoke
   */
  token: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type RevokeChatSessionSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RevokeChatSessionSecurityOption1$outboundSchema: z.ZodMiniType<
  RevokeChatSessionSecurityOption1$Outbound,
  RevokeChatSessionSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function revokeChatSessionSecurityOption1ToJSON(
  revokeChatSessionSecurityOption1: RevokeChatSessionSecurityOption1,
): string {
  return JSON.stringify(
    RevokeChatSessionSecurityOption1$outboundSchema.parse(
      revokeChatSessionSecurityOption1,
    ),
  );
}

/** @internal */
export type RevokeChatSessionSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RevokeChatSessionSecurityOption2$outboundSchema: z.ZodMiniType<
  RevokeChatSessionSecurityOption2$Outbound,
  RevokeChatSessionSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function revokeChatSessionSecurityOption2ToJSON(
  revokeChatSessionSecurityOption2: RevokeChatSessionSecurityOption2,
): string {
  return JSON.stringify(
    RevokeChatSessionSecurityOption2$outboundSchema.parse(
      revokeChatSessionSecurityOption2,
    ),
  );
}

/** @internal */
export type RevokeChatSessionSecurity$Outbound = {
  Option1?: RevokeChatSessionSecurityOption1$Outbound | undefined;
  Option2?: RevokeChatSessionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const RevokeChatSessionSecurity$outboundSchema: z.ZodMiniType<
  RevokeChatSessionSecurity$Outbound,
  RevokeChatSessionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RevokeChatSessionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RevokeChatSessionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function revokeChatSessionSecurityToJSON(
  revokeChatSessionSecurity: RevokeChatSessionSecurity,
): string {
  return JSON.stringify(
    RevokeChatSessionSecurity$outboundSchema.parse(revokeChatSessionSecurity),
  );
}

/** @internal */
export type RevokeChatSessionRequest$Outbound = {
  token: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const RevokeChatSessionRequest$outboundSchema: z.ZodMiniType<
  RevokeChatSessionRequest$Outbound,
  RevokeChatSessionRequest
> = z.pipe(
  z.object({
    token: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function revokeChatSessionRequestToJSON(
  revokeChatSessionRequest: RevokeChatSessionRequest,
): string {
  return JSON.stringify(
    RevokeChatSessionRequest$outboundSchema.parse(revokeChatSessionRequest),
  );
}
